import { parseISO } from "date-fns"

export const deserializeDate = (value: unknown) => {
  if (value === null) {
    return value
  }

  if (typeof value === "string") {
    return parseISO(value)
  }

  throw new Error("値が文字列型ではありません。")
}
